import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useRef, useEffect, useState } from 'react';
import ChevronLeftOutlinedIcon from '@material-ui/icons/ChevronLeftOutlined';
import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined';

function HomeCate(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const { title, prods, langs, isLocal } = props;
  const ref = useRef(null);

  const [showL, setShowL] = useState(true);
  const [showR, setShowR] = useState(true);

  let arrayClassName = () => {
    let classname = 'home-page-arrow-icon';
    if (theme?.highlight_scrollbar === 'true') classname += ' home-page-arrow-icon-highlight';
    return classname;
  };

  let cates = JSON.parse(localStorage.getItem('category'))
    ? JSON.parse(localStorage.getItem('category'))
    : [];

  const theme = JSON.parse(localStorage.getItem('machine'))?.themeColor;
  const showCateName = theme?.c_column === '4' ? true : false;

  const goCatePage = (catename, cateID) => {
    history.push(`/machineUI/category/cate/${catename}/${cateID}`);
  };

  const scroll = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
  };

  const runState = () => {
    if (ref) {
      setShowL(ref.current.scrollLeft === 0);
      setShowR(!(ref.current.scrollLeft < ref.current.scrollWidth - ref.current.clientWidth));
    }
  };

  const handleScroll = () => {
    runState();
  };

  useEffect(() => {
    runState();
  }, []);

  useEffect(() => {
    if (ref) {
      ref.current?.addEventListener('scroll', handleScroll, { passive: true });

      return () => {
        ref.current?.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  cates = cates?.sort((a, b) => {
    const nameA = a.name[langs] ? a.name[langs].toUpperCase() : a.name['en'].toUpperCase();
    const nameB = b.name[langs] ? b.name[langs].toUpperCase() : b.name['en'].toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    return 0;
  });

  const classnameForCateRow = () => {
    let myName = 'category-row';
    if (theme?.cate_image_button) {
      myName = `category-row mb-3`;
    }
    if (showCateName) {
      console.log('showCateName');
      myName = `category-row mb-10`;
    }

    return myName;
  };

  const result = cates.map((prod, i) => {
    const name = prod.name[langs] && prod.name[langs] !== '' ? prod.name[langs] : prod.name?.en;
    const url = isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/category/${prod.categoryPicture}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.categoryPicture}/${prod.referTo}`;
    if (theme?.cate_image_button === 'true') {
      return (
        <div className="home-cate-div" key={i}>
          <div className="d-flex flex-column justify-content-center align-items-center">
            <div
              className="home-cate-button home-cate-button-image d-flex align-items-center justify-content-center mr-2"
              style={{
                width: '234px',
                height: '130px',
              }}
              key={i}
              onClick={() => {
                localStorage.setItem('currentCate', JSON.stringify(prod));
                goCatePage(name, prod._id);
              }}
            >
              <img className="hundred-percent" src={url} />
            </div>
            {showCateName && (
              <div className="card-title" style={{ marginTop: '-20px' }}>
                {name}
              </div>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div className="home-cate-div" key={i}>
          <div
            className="home-cate-button d-flex align-items-center justify-content-center mr-3"
            key={i}
            onClick={() => {
              localStorage.setItem('currentCate', JSON.stringify(prod));
              goCatePage(name, prod._id);
            }}
          >
            <span className="home-cate-button-text">{name}</span>
          </div>
        </div>
      );
    }
  });

  let row1 = [];
  let row2 = [];
  let row3 = [];

  if (theme?.b_column === '1' && theme?.hide_bbs !== 'true') {
    if (result.length < 6) {
      for (let i = 1; i <= result.length; i++) {
        if (i < 4) {
          row1.push(result[i - 1]);
        } else {
          row2.push(result[i - 1]);
        }
      }
    } else {
      for (let i = 1; i <= result.length; i++) {
        if (i % 2 === 1) {
          row1.push(result[i - 1]);
        }
        if (i % 2 === 0) {
          row2.push(result[i - 1]);
        }
      }
    }
  } else {
    for (let i = 1; i <= result.length; i++) {
      if (i < 4) {
        row1.push(result[i - 1]);
      } else if (i < 7) {
        row2.push(result[i - 1]);
      } else if (i < 10) {
        row3.push(result[i - 1]);
      } else {
        if (i % 3 === 1) {
          row1.push(result[i - 1]);
        }
        if (i % 3 === 2) {
          row2.push(result[i - 1]);
        }
        if (i % 3 === 0) {
          row3.push(result[i - 1]);
        }
      }
    }
  }

  return (
    <div className="homeProduct">
      <h1 className="homeProductText mt-5 mb-5">{t(`Shop By Category`)}</h1>
      {/* <div className="home-product-container d-flex">{products}</div> */}
      {/* <div className="home-category-div">{result}</div> */}
      <div className="d-flex align-items-center">
        <div>
          <div style={{ width: '50px' }}>
            <ChevronLeftOutlinedIcon
              hidden={showL}
              className={arrayClassName()}
              onClick={() => scroll(-100)}
            />
          </div>
        </div>
        <div className="cate-container ml-2 mr-2 pl-3" ref={ref}>
          <div className={classnameForCateRow()}>{row1}</div>
          <div className={classnameForCateRow()}>{row2}</div>
          {row3.length > 0 && <div className={classnameForCateRow()}>{row3}</div>}
        </div>
        <div>
          <div style={{ width: '50px' }}>
            <ChevronRightOutlinedIcon
              hidden={showR}
              className={arrayClassName()}
              onClick={() => scroll(100)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default HomeCate;
